// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*Vertical Resizer = Vertical resizer to drag left and right
Horizontal Resizer  = Horizontal resizer to drag top and bottom*/

/*Below CSS stuff for the Vertical resizer, which are in action*/

#sidebar {
  left: 0;
  width: calc(25%);
  min-width: 200px;
}

#content {
  bottom: 0;
  right: 0;
  overflow: visible;
}

#sidebar-resizer {
  background-color: #e0e0e0;
  position: absolute;
  border-radius: 5px;
  top: 0px;
  bottom: 0;
  left: calc(25% - 3px);
  width: 5px;
  cursor: col-resize;
}

#sidebar-resizer:hover,
#preview-resizer:hover {
  background-color: #c1c1c1;
}

/*In future if need to do horizontal resizer., then use below classes*/

/*#topnav {
    background-color: #333333;
    display: block;
    height: 35px;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    background-color: #DDD;
}*/

/*#top-content {
    position: absolute;
    top: 0;
    bottom: 136px;  130 + 6 
    left: 0;
    right: 0;
    background-color: #444;
    overflow: auto;
}*/

/*#bottom-content {
    position: absolute;
    height: 130px;
    bottom: 0;
    left: 0;
    right: 0;
    overflow: auto;
    background-color: #777;
}*/

/*#content-resizer {
    position: absolute;
    height: 5px;
    bottom: 130px;
    left: 0;
    right: 0;
    background-color: #666;
    cursor: n-resize;
}*/
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/components/resizer.css"],"names":[],"mappings":"AAAA;gEACgE;;AAEhE,gEAAgE;;AAEhE;EACE,OAAO;EACP,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,qBAAqB;EACrB,UAAU;EACV,kBAAkB;AACpB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA,sEAAsE;;AAEtE;;;;;;;;;EASE;;AAEF;;;;;;;;EAQE;;AAEF;;;;;;;;EAQE;;AAEF;;;;;;;;EAQE","sourcesContent":["/*Vertical Resizer = Vertical resizer to drag left and right\nHorizontal Resizer  = Horizontal resizer to drag top and bottom*/\n\n/*Below CSS stuff for the Vertical resizer, which are in action*/\n\n#sidebar {\n  left: 0;\n  width: calc(25%);\n  min-width: 200px;\n}\n\n#content {\n  bottom: 0;\n  right: 0;\n  overflow: visible;\n}\n\n#sidebar-resizer {\n  background-color: #e0e0e0;\n  position: absolute;\n  border-radius: 5px;\n  top: 0px;\n  bottom: 0;\n  left: calc(25% - 3px);\n  width: 5px;\n  cursor: col-resize;\n}\n\n#sidebar-resizer:hover,\n#preview-resizer:hover {\n  background-color: #c1c1c1;\n}\n\n/*In future if need to do horizontal resizer., then use below classes*/\n\n/*#topnav {\n    background-color: #333333;\n    display: block;\n    height: 35px;\n    left: 0;\n    position: absolute;\n    right: 0;\n    top: 0;\n    background-color: #DDD;\n}*/\n\n/*#top-content {\n    position: absolute;\n    top: 0;\n    bottom: 136px;  130 + 6 \n    left: 0;\n    right: 0;\n    background-color: #444;\n    overflow: auto;\n}*/\n\n/*#bottom-content {\n    position: absolute;\n    height: 130px;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    overflow: auto;\n    background-color: #777;\n}*/\n\n/*#content-resizer {\n    position: absolute;\n    height: 5px;\n    bottom: 130px;\n    left: 0;\n    right: 0;\n    background-color: #666;\n    cursor: n-resize;\n}*/\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
